export const TaskAgreementTypeLabel = {
  0: 'Administrador',
  1: 'Tiempo',
  2: 'Acuerdo',
  3: 'Sistema',
}
